import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-name-exists',
    templateUrl: './name-exists.component.html',
    styleUrls: ['./name-exists.component.scss'],
    standalone: true,
    imports: [
        TranslateModule,
    ],
})
export class NameExistsComponent {
    @Input({ required: true }) existingName: string;
    @Input({ required: true }) suggestedPrefix: string;
    @Input() titleText: string;
    @Input() bodyText: string;

    get title(): string { return this.titleText ?? 'generics.name-exists-title'; }
    get body(): string { return this.bodyText ?? 'generics.name-exists-body'; }
}